import React from 'react';
import ReactDOM from 'react-dom/client'; // 从 react-dom/client 导入 createRoot
import { Provider } from 'react-redux';
import store from './store';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import './i18n';
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement);

root.render(
    // <React.StrictMode> //React.StrictMode严格模式会执行两次代码
        <Provider store={store}>
            {/* <Router basename='/personal'> */}
            {/* <Router> */}
                <App />
            {/* </Router> */}
        </Provider>
    //  </React.StrictMode>
);
